import { render, staticRenderFns } from "./AdminNoticesForm.vue?vue&type=template&id=af95a7d0&scoped=true"
import script from "./AdminNoticesForm.vue?vue&type=script&lang=js"
export * from "./AdminNoticesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af95a7d0",
  null
  
)

export default component.exports